module.exports = __webpack_public_path__ + "img/cup.724c907a.png";